/* eslint-disable comma-dangle, space-in-parens */
// Comma dangle was screwing up the lazy import
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import constants from 'utils/constants';

import ModifyRecurringTransfer from 'components/recurringTransferWorkflow/ModifyRecurringTransfer';

import CreateRecurringTransfer from 'components/recurringTransferWorkflow/CreateRecurringTransfer';

export default function RecurringRoutes() {
  return (
    <Switch>
      <Route
        path={`${constants.WORKFLOWS.CREATE_RECURRING_TRANSFERS}/:action/:id`}
        component={ModifyRecurringTransfer}
      />
      <Route
        path={constants.WORKFLOWS.CREATE_RECURRING_TRANSFERS}
        component={CreateRecurringTransfer}
      />
    </Switch>
  );
}
